import { render } from "./TelemedicineContentEn.vue?vue&type=template&id=0ddff954"
import script from "./TelemedicineContentEn.vue?vue&type=script&lang=js"
export * from "./TelemedicineContentEn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__